var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.forum
    ? _c(
        "div",
        { staticClass: "class-page topic-page" },
        [
          _c("class-page-header", {
            attrs: {
              details: _vm.details,
              "current-section": parseInt(_vm.sectionId),
              course: _vm.course,
              menu: _vm.menu,
              "is-class-item-page": true,
              "course-content": _vm.courseContent
            }
          }),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.forum.TITLE))]),
          _vm._v(" "),
          !!_vm.forum.TOPICS &&
          _vm.forum.TOPICS.length &&
          _vm.forum.STUDENTS_CREATE_TOPIC_FLG === "Y"
            ? _c("div", { staticClass: "text-right mb-1em" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-new",
                    attrs: {
                      type: "button",
                      fields: {},
                      "data-toggle": "modal",
                      "data-target": "#addNewModal"
                    },
                    on: { click: _vm.addTopic }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus-circle" }),
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("MAIN_CONTENT.Forum.newTopic")) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !!_vm.forum.TOPICS && !_vm.forum.TOPICS.length
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "25px",
                    "margin-bottom": "25px",
                    padding: "35px",
                    "border-radius": "5px",
                    border: "3px dashed #CCC"
                  }
                },
                [
                  _c("h2", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("MAIN_CONTENT.Forum.noTopicsMessage")) +
                        "\n\t\t\t\t\t\t"
                    ),
                    _vm.forum.STUDENTS_CREATE_TOPIC_FLG === "Y"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-new",
                            attrs: {
                              type: "button",
                              fields: {},
                              "data-toggle": "modal",
                              "data-target": "#addNewModal"
                            },
                            on: { click: _vm.addTopic }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus-circle" }),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("MAIN_CONTENT.Forum.newTopic")) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.forum.TOPICS, function(topic, index) {
            return _c(
              "div",
              { key: topic.TOPIC_ID, staticClass: "topic-box topics" },
              [
                _c("div", { staticClass: "row" }, [
                  topic.POSTER_PHOTO_URL
                    ? _c("img", {
                        staticClass:
                          "col-xs-3 col-md-2 img-responsive rounded cp-student-photo-image-circle",
                        attrs: { src: topic.POSTER_PHOTO_URL, alt: "Photo" }
                      })
                    : _c("img", {
                        staticClass:
                          "col-xs-3 col-md-2 img-responsive cp-student-photo-image-circle",
                        attrs: {
                          src:
                            "/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png",
                          alt: "Photo"
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-10" }, [
                    !!topic.USER_NAME
                      ? _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.Forum.topicHeader", {
                                  label: topic.USER_NAME
                                })
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t"
                          )
                        ])
                      : !!topic.MODIFIED_BY
                      ? _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.Forum.topicHeader", {
                                  label: topic.MODIFIED_BY
                                })
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t"
                          )
                        ])
                      : _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.Forum.topicHeader", {
                                  label: topic.CREATED_BY
                                })
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t"
                          )
                        ]),
                    _vm._v(" "),
                    _c("p", [
                      topic.NEW_POSTS_FLG === "Y"
                        ? _c(
                            "span",
                            { staticClass: "badge badge-pill bg-teal" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.commonContent.newPosts"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goToPosts(topic.TOPIC_ID)
                            }
                          }
                        },
                        [_c("strong", [_vm._v(_vm._s(topic.TITLE))])]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(topic.SUBJECT))]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "topic-preview",
                      domProps: { innerHTML: _vm._s(topic.MESSAGE) }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row actions" }, [
                  _vm.selectedStudent.STUDENT_RID === topic.CREATED_BY
                    ? _c(
                        "a",
                        {
                          staticClass: "btn on-grey",
                          attrs: { href: "/edit/" + topic.TOPIC_ID },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.editTopic(topic)
                            }
                          }
                        },
                        [
                          _c("strong", [
                            _c("i", { staticClass: "fa fa-pen" }),
                            _vm._v(" " + _vm._s(_vm.$t("commonText.edit")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn posts-comments-btn",
                      on: {
                        click: function($event) {
                          return _vm.goToPosts(topic.TOPIC_ID)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-comments on-teal" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "badge badge-pill bg-teal" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                            _vm._s(
                              topic.NUMBER_OF_REPLIES
                                ? topic.NUMBER_OF_REPLIES - 1
                                : 0
                            ) +
                            "\n\t\t\t\t\t\t\t\t\t\t"
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          }),
          _vm._v(" "),
          !!_vm.forum
            ? _c(
                "modal",
                {
                  attrs: {
                    "modal-title": _vm.$t("MAIN_CONTENT.Forum.newTopic"),
                    show: _vm.showNewTopicModal,
                    "dialog-size": "lg",
                    name: "newTopicModal"
                  },
                  on: {
                    close: function($event) {
                      _vm.showNewTopicModal = false
                    }
                  }
                },
                [
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "title" } }, [
                        _vm._v(_vm._s(_vm.$t("commonText.title")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.topic.TITLE,
                            expression: "topic.TITLE",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "title",
                          placeholder: _vm.$t("commonText.title")
                        },
                        domProps: { value: _vm.topic.TITLE },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.topic,
                              "TITLE",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Forum.message")))
                        ]),
                        _vm._v(" "),
                        _c("ckeditor4", {
                          attrs: {
                            config: _vm.editorConfig,
                            simpleImagesDialog: true,
                            id: "message"
                          },
                          model: {
                            value: _vm.topic.MESSAGE,
                            callback: function($$v) {
                              _vm.$set(_vm.topic, "MESSAGE", $$v)
                            },
                            expression: "topic.MESSAGE"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  _vm._v(" "),
                  _c("template", { slot: "footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showNewTopicModal = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("commonText.cancel")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-new",
                        attrs: { type: "button" },
                        on: { click: _vm.createTopic }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.commonContent.submit")
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.forum
            ? _c(
                "modal",
                {
                  attrs: {
                    "modal-title": _vm.$t("MAIN_CONTENT.Forum.editTopic"),
                    show: _vm.showEditTopicModal,
                    "dialog-size": "lg",
                    name: "editTopicModal"
                  },
                  on: {
                    close: function($event) {
                      _vm.showEditTopicModal = false
                    }
                  }
                },
                [
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "title" } }, [
                        _vm._v(_vm._s(_vm.$t("commonText.title")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.topic.TITLE,
                            expression: "topic.TITLE",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "title",
                          placeholder: _vm.$t("commonText.title")
                        },
                        domProps: { value: _vm.topic.TITLE },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.topic,
                              "TITLE",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("MAIN_CONTENT.Forum.message")) +
                              "\n\t\t\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ckeditor4", {
                          attrs: {
                            config: _vm.editorConfig,
                            simpleImagesDialog: true,
                            id: "message"
                          },
                          model: {
                            value: _vm.topic.MESSAGE,
                            callback: function($$v) {
                              _vm.$set(_vm.topic, "MESSAGE", $$v)
                            },
                            expression: "topic.MESSAGE"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  _vm._v(" "),
                  _c("template", { slot: "footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showEditTopicModal = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.commonContent.closeButton")
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-new",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.updateTopic(_vm.topic)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("commonText.save")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("class-page-footer", {
            attrs: {
              course: _vm.course,
              menu: _vm.menu,
              "current-section": parseInt(_vm.sectionId),
              "is-class-item-page": true,
              "course-content": _vm.courseContent
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }